/** Bentuk satu frame orb — dipakai bersama penggambar varian dan dispatcher. */

import type { Rgb } from "./orb-colors";

export interface OrbFrame {
	/** Tangga warna siap pakai (sudah disesuaikan tema). */
	ramp: readonly Rgb[];
	/** Parameter varian dalam bentuk bernama. */
	params: Readonly<Record<string, number>>;
	/** Detik sejak animasi mulai; 0 = frame statis. */
	time: number;
	/** Sisi render dalam piksel CSS — menentukan kerapatan & varian efektif. */
	cssSize: number;
	/** Tema terang perlu opasitas dasar lebih tinggi agar titik tidak lenyap. */
	light: boolean;
	/** Kecerahan keseluruhan 0–1 (dipakai peredupan saat idle). */
	brightness: number;
}

/**
 * Jari-jari bola sebagai pecahan sisi kanvas. Dinaikkan dari 0.38 agar bola
 * mengisi kanvas lebih penuh — orb lama tampak kecil karena terlalu banyak
 * ruang kosong untuk glow di tepinya. 0.45 masih menyisakan margin untuk aura.
 */
export const RADIUS_RATIO = 0.45;

/** Satu penggambar varian. */
export type OrbPainter = (
	ctx: CanvasRenderingContext2D,
	cx: number,
	cy: number,
	radius: number,
	frame: OrbFrame,
) => void;

/**
 * Nilai parameter bernama, dengan cadangan bila slotnya belum ada. Konfigurasi
 * lama tetap bisa dirender walau daftar parameter varian bertambah.
 */
export const paramOr = (
	params: Readonly<Record<string, number>>,
	key: string,
	fallback: number,
): number =>
	Number.isFinite(params[key]) ? (params[key] as number) : fallback;
